module.exports = __webpack_public_path__ + "img/Illustrations-groovy.3b4fecdf.svg";